module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M21.8 0h-12C8.696 0 8 .894 8 2v2H1.8C.696 4 0 4.894 0 6v24c0 1.106.696 2 1.8 2h28c1.106 0 2.2-.894 2.2-2V6c0-1.106-1.094-2-2.2-2H24V2c0-1.106-1.094-2-2.2-2zm-6 12c2.208 0 4 1.794 4 4s-1.792 4-4 4-4-1.794-4-4 1.794-4 4-4zM28 16v12H4V16h3.8c0 4.412 3.59 8 8 8s8-3.588 8-8H28z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/camera-4.js
// module id = 1046
// module chunks = 14